import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eecdbb96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-selector" }
const _hoisted_2 = {
  key: 0,
  class: "selected-family"
}
const _hoisted_3 = { key: 1 }

import { computed, nextTick, ref, watch } from 'vue'
import { useLiveFamilySearch } from '@/rd/LivePersonSearch'
import { livingWindowStart, ViewFamily } from '@/rd/ResearchDataModel'
import FamilyCard from './FamilyCard.vue'
import SearchInput from "@/util/SearchInput.vue"
import FamilyListItem from './FamilyListItem.vue'
import { useViewPersonStore } from '@/rd/ViewPersonStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilySelector',
  props: {
    modelValue: {},
    livingOnly: { type: Boolean },
    disabled: { type: Boolean },
    placeholder: {},
    postFilter: { type: Function }
  },
  emits: [
  'update:modelValue',
  'focus'
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  focus: () => searchInputRef.value?.focus(),
  reset
})

const removeButtonRef = ref<HTMLButtonElement>()
const searchInputRef = ref<InstanceType<typeof SearchInput>>()

const viewPersonStore = useViewPersonStore()

const placeholderRef = computed(() => props.placeholder ?? "Type a name")
const { searchTextRef, searchResultsRef } = useLiveFamilySearch(props.postFilter)

const filteredSearchResultsRef = computed(() => {
  const results = searchResultsRef.value
  if (props.livingOnly) {
    return results.filter(vf => {
      const faBirthYear = getFather(vf)?.birthYear
      const moBirthYear = getMother(vf)?.birthYear
      const latestBirthYear = Math.max(faBirthYear ?? 0, moBirthYear ?? 0)
      return latestBirthYear >= livingWindowStart
    })
  }
  return results
})

function getFather(vf: ViewFamily) {
  return viewPersonStore.getLoadedPerson(vf.fatherId)
}

function getMother(vf: ViewFamily) {
  return viewPersonStore.getLoadedPerson(vf.motherId)
}

async function searchResultSelected(id: string) {
  emit('update:modelValue', id)
  await nextTick()
  removeButtonRef.value?.focus()
}

async function removeSelectedFamily() {
  emit('update:modelValue', undefined)
  await nextTick()
  searchInputRef.value?.focus()
}

function reset() {
  searchTextRef.value = ""
  searchInputRef.value?.reset()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(FamilyCard, {
            "family-id": _ctx.modelValue,
            "show-profile-type": "",
            "select-mode": "",
            onClick: removeSelectedFamily
          }, null, 8, ["family-id"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SearchInput, {
            ref_key: "searchInputRef",
            ref: searchInputRef,
            modelValue: _unref(searchTextRef),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTextRef) ? (searchTextRef).value = $event : null)),
            "search-results": filteredSearchResultsRef.value,
            placeholder: placeholderRef.value,
            disabled: _ctx.disabled,
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus'))),
            onResultSelected: searchResultSelected
          }, {
            default: _withCtx(({ item }) => [
              _createVNode(FamilyListItem, {
                "family-id": item.id!,
                father: getFather(item as ViewFamily),
                mother: getMother(item as ViewFamily)
              }, null, 8, ["family-id", "father", "mother"])
            ]),
            _: 1
          }, 8, ["modelValue", "search-results", "placeholder", "disabled"])
        ]))
  ]))
}
}

})